import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import TotalMeter from "./Componets/TotalMeter";
import GroupWise from "./Componets/GroupWise";
import QualityWise from "./Componets/QualityWise";
import PartyWise from "./Componets/PartyWise";
import { Col, Row } from "react-bootstrap";
import { CiSearch } from "react-icons/ci";
import { useSelector } from "react-redux";
import Cookies from "js-cookie";
import { Offcanvas, Button } from "react-bootstrap";
import { FiMenu } from "react-icons/fi";
import { Loader } from "../../../components/Loader/Loader";
import { FilterBox } from "../../../components/FilterBox/FilterBox";
import { useTheme } from "../../../Themecontext/Themecontext";


export const Balance = () => {

  const location = useLocation();
  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState("GroupWise");

  const { mainFilterData } = useSelector((state) => state.ClientLogin);
  const { Colourdata } = useSelector((state) => state.ClientLogin);

  console.log(mainFilterData?.production_Group_Master_List);
  console.log(mainFilterData?.account_list);


  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "GRAYNEW");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "GRAYDARKNEW",
  );

  const { theme } = useTheme();
  const isdark = theme;



  const [filters, setFilters] = useState({
    production: [],
    account: [],
  });

  const [search, setSearch] = useState({
    production: "",
    account: "",
  });

  const productionGroups =
    mainFilterData?.production_Group_Master_List?.map((item) => ({
      label: item.ProductionGroupMstName,
      value: item.ProductionGroupMstID,
    })) || [];

  const accountGroups =
    mainFilterData?.account_list?.map((item) => ({
      label: item.AcName,
      value: item.AcID,
    })) || [];

  // Voice Search Handle Effect
  useEffect(() => {
    if (location.state?.searchParty && mainFilterData?.account_list && mainFilterData.account_list.length > 0) {
      const searchName = location.state.searchParty.toLowerCase();
      
      const stringSimilarity = (str1, str2) => {
        const getBigrams = (str) => {
          let bigrams = new Set();
          for (let i = 0; i < str.length - 1; i++) {
            bigrams.add(str.substring(i, i + 2));
          }
          return bigrams;
        };
        const bg1 = getBigrams(str1);
        const bg2 = getBigrams(str2);
        const union = bg1.size + bg2.size;
        if (union === 0) return 1;
        let hits = 0;
        for (let bg of bg1) {
          if (bg2.has(bg)) hits++;
        }
        return (2.0 * hits) / union;
      };

      const cleanString = (str) => {
        return str.replace(/\b(private|limited|pvt|ltd|and|co|company|opening)\b/gi, '').replace(/\s+/g, ' ').trim();
      };
      
      const cleanedSearch = cleanString(searchName);
      
      let bestMatch = null;
      let highestScore = 0;
      
      mainFilterData.account_list.forEach(a => {
        const accLabel = a.AcName.toLowerCase();
        const cleanedLabel = cleanString(accLabel);
        
        let score = 0;
        
        if (accLabel === searchName) {
          score = 10;
        } else if (accLabel.includes(searchName)) {
          score = 5;
        } else {
          score = stringSimilarity(cleanedSearch, cleanedLabel);
          const searchWords = cleanedSearch.split(' ');
          const labelWords = cleanedLabel.split(' ');
          if (searchWords[0] && labelWords[0] && searchWords[0].length > 2) {
            if (labelWords[0].includes(searchWords[0]) || searchWords[0].includes(labelWords[0])) {
               score += 0.5;
            }
          }
        }
        
        if (score > highestScore) {
          highestScore = score;
          bestMatch = a;
        }
      });
      
      const matchedAccount = highestScore > 0.3 ? bestMatch : null;
      
      if (matchedAccount) {
        setActiveTab("PartyWise");
        setFilters(prev => {
          if (!prev.account.includes(matchedAccount.AcID)) {
            return { ...prev, account: [matchedAccount.AcID] };
          }
          return prev;
        });
        
        navigate(location.pathname, { replace: true, state: {} });
      }
    }
  }, [location.state, mainFilterData, navigate, location.pathname]);


  const toggleItem = (type, item) => {
    setFilters((prev) => {
      const selected = prev[type];

      return {
        ...prev,
        [type]: selected.includes(item.value)
          ? selected.filter((i) => i !== item.value)
          : [...selected, item.value],
      };
    });
  };

  const selectAll = (type, items) => {
    const allIds = items.map((i) => i.value);

    setFilters((prev) => ({
      ...prev,
      [type]:
        prev[type].length === items.length ? [] : allIds,
    }));
  };

  const handleSearch = (type, value) => {
    setSearch((prev) => ({
      ...prev,
      [type]: value,
    }));
  };

  const renderPage = () => {
    const commonProps = {
      selectedProduction: filters.production,
      selectedAccount: filters.account,
    };

    switch (activeTab) {
      case "GroupWise":
        return <GroupWise {...commonProps} />;
      case "QualityWise":
        return <QualityWise {...commonProps} />;
      case "PartyWise":
        return <PartyWise {...commonProps} />;
      default:
        return <TotalMeter {...commonProps} />;
    }
  };


  const [showFilter, setShowFilter] = useState(false);

  const handleClose = () => setShowFilter(false);
  const handleShow = () => setShowFilter(true);

  if (!mainFilterData) {
    return (
      <div className="flex justify-center items-center h-screen text-xl text-green-700">
        <Loader />
      </div>
    );
  }

  return (
    <div className="pageContainer">
      {/* 🔷 TITLE */}
      <Row className="mb-3 align-items-center">
        {/* OFFCANVAS */}
        <Offcanvas show={showFilter} onHide={handleClose} placement="start"
          style={{
            background:
              isdark === "light" ? iscolour?.Colour7 : iscolourDark?.Colour10,
          }}
        >
          <Offcanvas.Header closeButton
            closeVariant={isdark === "dark" ? "white" : undefined}
            style={{ color: isdark === "light" ? "#000" : "#FFF", }}
          >
            <Offcanvas.Title>Filters</Offcanvas.Title>
          </Offcanvas.Header>

          <Offcanvas.Body>
            <div style={{ gap: "15px", flexDirection: "column", display: "flex" }}>

              {/* PRODUCTION FILTER */}
              <FilterBox
                title="Production Group"
                items={productionGroups}
                search={search.production}
                setSearch={(val) => handleSearch("production", val)}
                selectedItems={filters.production}
                toggleItem={(item) => toggleItem("production", item)}
                selectAll={() => selectAll("production", productionGroups)}
              />

              {/* ACCOUNT FILTER */}
              <FilterBox
                title="Account Group"
                items={accountGroups}
                search={search.account}
                setSearch={(val) => handleSearch("account", val)}
                selectedItems={filters.account}
                toggleItem={(item) => toggleItem("account", item)}
                selectAll={() => selectAll("account", accountGroups)}
              />
            </div>
          </Offcanvas.Body>
        </Offcanvas>

        {/* Only show on md & below */}
        <div xs={4} className="d-lg-none text-end">
          <Button onClick={handleShow}
            style={{
              border: "none",
              backgroundColor:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour1,
              color:
                isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour8,
            }}
          >
            <FiMenu size={22} />
          </Button>
        </div>
      </Row>

      {/*  TABS */}
      <Row className="mb-4  g-2">
        {["GroupWise", "QualityWise", "PartyWise"].map(
          (tab) => (
            <Col xs={12} sm={4} lg={4} key={tab}>
              <button
                onClick={() => setActiveTab(tab)}
                className="hover-scale-btn"
                style={{
                  width: "100%",
                  height: "58px",
                  backgroundColor:
                    activeTab === tab
                      ? isdark === "light"
                        ? iscolour?.Colour1
                        : iscolourDark?.Colour1
                      : isdark === "light"
                        ? iscolour?.Colour5
                        : iscolourDark?.Colour10,
                  color:
                    activeTab === tab
                      ? isdark === "light"
                        ? iscolour?.Colour5
                        : iscolourDark?.Colour8
                      : isdark === "light"
                        ? iscolour?.Colour2
                        : iscolourDark?.Colour2,
                  border: `2px solid ${isdark === "light"
                    ? iscolour?.Colour4
                    : "rgb(149 213 178 / 25%)"
                    }`,
                  borderRadius: "12px",
                  cursor: "pointer",
                  fontWeight: "bold",
                }}
              >
                {tab}
              </button>
            </Col>
          )
        )}
      </Row>

      {/*  MAIN CONTENT (FILTER + TABLE) */}
      <Row className="g-4 align-items-start">

        {/* LEFT FILTER */}
        <Col xl={3} lg={4} md={12} sm={12} className="d-none d-lg-block">
          <div style={{ gap: "15px", flexDirection: "column", display: "flex" }}>

            {/*  PRODUCTION FILTER */}
            <FilterBox
              title="Production Group"
              items={productionGroups}
              search={search.production}
              setSearch={(val) => handleSearch("production", val)}
              selectedItems={filters.production}
              toggleItem={(item) => toggleItem("production", item)}
              selectAll={() => selectAll("production", productionGroups)}
            />

            {/*  ACCOUNT FILTER */}
            <FilterBox
              title="Account Group"
              items={accountGroups}
              search={search.account}
              setSearch={(val) => handleSearch("account", val)}
              selectedItems={filters.account}
              toggleItem={(item) => toggleItem("account", item)}
              selectAll={() => selectAll("account", accountGroups)}
            />
          </div>
        </Col>

        {/* RIGHT CONTENT */}
        <Col xl={9} lg={8} md={12} sm={12} style={{ minWidth: 0, overflowX: "auto" }}>
          {renderPage()}
        </Col>

      </Row>
    </div >
  );
};